import { makeActionCreator } from '../../../utilities'
import { DiagnosisConstants } from './diagnosis.constants'

export const setInitialPatientAcuity = makeActionCreator(
  DiagnosisConstants.SET_INITIAL_PATIENT_ACUITY,
  'initialPatientAcuity'
)
export const setInitialPatientAcuityPNNV = makeActionCreator(
  DiagnosisConstants.SET_INITIAL_PATIENT_ACUITY_PNNV,
  'initialPatientAcuityPNNV'
)
export const setOrganSystems = makeActionCreator(DiagnosisConstants.SET_ORGAN_SYSTEM, 'organSystems')
export const setOrganSystemPNNV = makeActionCreator(DiagnosisConstants.SET_ORGAN_SYSTEM_PNNV, 'organSystemsPNNV')
export const setSymptoms = makeActionCreator(DiagnosisConstants.SET_SYMPTOMS, 'symptoms')
export const setSymptomsPNNVs = makeActionCreator(DiagnosisConstants.SET_SYMPTOMS_PNNVS, 'symptomsPNNVs')
export const setImpressions = makeActionCreator(DiagnosisConstants.SET_IMPRESSIONS, 'impressions')
export const setImpressionsPNNV = makeActionCreator(DiagnosisConstants.SET_IMPRESSIONS_PNNV, 'impressionsPNNV')
export const setAnatomicLocation = makeActionCreator(DiagnosisConstants.SET_ANATOMIC_LOCATION, 'anatomicLocation')
export const setAnatomicLocationPNNV = makeActionCreator(
  DiagnosisConstants.SET_ANATOMIC_LOCATION_PNNV,
  'anatomicLocationPNNV'
)
export const setWorkingDiagnosis = makeActionCreator(DiagnosisConstants.SET_WORKING_DIAGNOSIS, 'workingDiagnosis')
export const setFinalPatientAcuity = makeActionCreator(
  DiagnosisConstants.SET_FINAL_PATIENT_ACUITY,
  'finalPatientAcuity'
)
export const setFinalPatientAcuityPNNV = makeActionCreator(
  DiagnosisConstants.SET_FINAL_PATIENT_ACUITY_PNNV,
  'finalPatientAcuityPNNV'
)
export const setConditionAtDestination = makeActionCreator(
  DiagnosisConstants.SET_CONDITION_AT_DESTINATION,
  'conditionAtDestination'
)
export const setDiagnosisState = makeActionCreator(DiagnosisConstants.SET_DIAGNOSIS_STATE, 'diagnosis')
export const resetDiagnosisState = makeActionCreator(DiagnosisConstants.RESET_DIAGNOSIS)
